var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJupyterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.280134 0 0 1.280134 -2089.590391 -2679.717298)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    fill: "#767677",
    x: 1669.3,
    y: 2093.31
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f37726"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 1639.74,
    y: 2123.98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 1639.73,
    y: 2097.48
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    fill: "#989798",
    x: 1639.8,
    y: 2135.81
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    fill: "#6f7070",
    x: 1638.36,
    y: 2098.06
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M5.894 2.844c.025.588-.123 1.17-.425 1.672s-.746.904-1.275 1.152-1.12.333-1.695.243a2.94 2.94 0 0 1-1.543-.748 2.98 2.98 0 0 1-.871-1.486c-.138-.57-.105-1.17.095-1.724A2.97 2.97 0 0 1 1.208.574 2.93 2.93 0 0 1 2.823.003c.78-.033 1.542.247 2.118.78s.918 1.274.952 2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M18.265 7.134C10.415 7.134 3.56 4.258 0 0c1.325 3.82 3.796 7.13 7.07 9.473s7.187 3.6 11.2 3.6 7.927-1.258 11.2-3.6S35.213 3.82 36.538 0C32.97 4.258 26.115 7.134 18.265 7.134z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M18.273 5.94c7.85 0 14.706 2.877 18.265 7.134-1.325-3.82-3.796-7.13-7.07-9.473S22.282 0 18.27 0s-7.927 1.258-11.2 3.6S1.325 9.253 0 13.073C3.567 8.825 10.423 5.94 18.273 5.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M7.428 3.583a3.77 3.77 0 0 1-.536 2.109c-.382.634-.94 1.14-1.608 1.452s-1.4.42-2.137.306-1.404-.442-1.945-.944S.28 5.353.105 4.632a3.78 3.78 0 0 1 .122-2.173c.253-.696.705-1.3 1.3-1.74S2.83.033 3.564.003c.983-.04 1.94.314 2.666.985a3.76 3.76 0 0 1 1.198 2.596z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M2.275 4.396c-.43.02-.858-.092-1.227-.318S.385 3.52.203 3.127-.04 2.292.026 1.862.283 1.03.575.71s.672-.546 1.09-.65.86-.078 1.265.072.757.417 1.01.77a2.21 2.21 0 0 1-.156 2.784c-.39.43-.934.684-1.51.71z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupyterLogo);
export default __webpack_public_path__ + "static/media/jupyter_logo.eaf88c5999e7e478ab4cbddb7e5cfde5.svg";
export { ForwardRef as ReactComponent };